import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Instagram, WhatsApp, Telegram, Phone } from '@mui/icons-material';
import LogoGame from '../assetts/icons/logo-game-zone-vip.png';

const AboutUs = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        color: '#e0e0e0',
        borderBottom: '1px solid #a415f8',
        padding: '60px 20px',
        borderRadius: '12px',
        position: 'relative',
        overflow: 'hidden',
        flexDirection: { xs: 'column', sm: 'row' },
        boxShadow: '0 1px 10px #a415f8',
      }}
    >
      <Box
        component="img"
        src={LogoGame}
        alt="About Us"
        sx={{
          width: { xs: '100%', sm: '50%' },
          height: 'auto',
          borderRadius: '12px',
          boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.7)',
          transition: 'transform 0.3s ease-in-out',
          marginBottom: { xs: '20px', sm: '0' },
        }}
      />
      <Box
        sx={{
          width: { xs: '90%', sm: '40%' },
          textAlign: { xs: 'center', sm: 'left' },
          ml: { sm: '20px' },
        }}
      >
        <Typography
          variant="h4"
          fontWeight="700"
          gutterBottom
          sx={{
            fontSize: { xs: '2.2rem', sm: '3rem' },
            color: '#750fb4de',
          }}
        >
          О Нас
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            fontSize: { xs: '1rem', sm: '1.1rem' },
            color: '#b0b0b0',
            mb: 3,
          }}
        >
          Добро пожаловать в <strong>Game Zone</strong> — ваш идеальный клуб для
          развлечений на PlayStation 5! Мы рады предложить вам уникальную
          возможность погрузиться в мир невероятных игр, где революционная
          графика и высокая производительность создают незабываемые впечатления.
          <br />
          <br />
          Цены начинаются от{' '}
          <strong style={{ color: '#750fb4' }}>200 сом</strong>. Присоединяйтесь
          к нам и станьте частью захватывающего игрового сообщества!
        </Typography>
        {/* Social Icons */}
        <Box
          sx={{
            display: 'flex',
            gap: 1.5,
            justifyContent: { xs: 'center', sm: 'flex-start' },
            mt: 3,
          }}
        >
          <IconButton
            color="inherit"
            href="https://wa.me/996705130070?text=Здравствуйте, хотел(а) забронировать зал..."
            target="_blank"
          >
            <WhatsApp fontSize="large" sx={{ color: '#25D366' }} />
          </IconButton>

          <IconButton
            color="inherit"
            href="https://t.me/+996705130070"
            target="_blank"
          >
            <Telegram fontSize="large" sx={{ color: '#0088cc' }} />
          </IconButton>

          <IconButton
            color="inherit"
            href="https://www.instagram.com/game.zone.kg/"
            target="_blank"
          >
            <Instagram fontSize="large" sx={{ color: '#E4405F' }} />
          </IconButton>

          <IconButton color="inherit" href="tel:+996705130070">
            <Phone fontSize="large" sx={{ color: '#750fb4' }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUs;
